import { Field, Checkbox, TextOutput } from 'Components/Core';
import { FieldSet } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'rxjs';
import { ICoreFieldProps } from './types';

let MaterialHistory: React.FC<ICoreFieldProps> = ({
  createWorksheetSelector,
  editable = false,
  visible = true,
  appendNamePrefix = '',
}) => {
  const materialHistoryChecked = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.MaterialPreviouslyOvenDried`), valueOrDefault(false))
  );

  if (!visible) {
    return null;
  }

  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      {editable ? (
        <FieldSet>
          <Field input={<Checkbox />} label="Material previously oven dried" name="MaterialPreviouslyOvenDried" />
        </FieldSet>
      ) : (
        <FieldSet>
          <Field
            input={<TextOutput />}
            label="Material History"
            value={
              materialHistoryChecked
                ? 'Material has been previously oven dried'
                : 'Material has not been previously oven dried'
            }
          />
        </FieldSet>
      )}
    </NamePrefixModifier>
  );
};

MaterialHistory = withInjectedProps(MaterialHistory);

export { MaterialHistory };
